import * as React from "react";
import { connect } from "react-redux";
import { selectStoreCategoryDefaultIndex } from "../../balancingSelectors/selectBalancingUiDefinitions";
import { IdMenuBalancing } from "../../constants/IdMenuBalancing";
import { selectModalTabId } from "../../selectors/selectModalTabId";
import { componentWithProps } from "../generic/componentWithProps";
import { ResourceBar } from "../generic/resource-bar/ResourceBar";
import { menuTabs } from "../menus/menuTabs";
import { MenuWrapper } from "../menus/MenuWrapper";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
export var _MenuStore = function (_a) {
    var onClose = _a.onClose, tabId = _a.tabId;
    var categoryConfig = tabId ? menuTabs[IdMenuBalancing.Store].categories[tabId] : undefined;
    var resourcesToDisplay = categoryConfig ? categoryConfig.footerResources || [] : [];
    var footerComponent = componentWithProps({
        ComponentType: ResourceBar,
        resources: resourcesToDisplay,
    });
    var defaultTabIndex = selectStoreCategoryDefaultIndex();
    return (React.createElement(MenuWrapper, { onClose: onClose, className: "shop-menu", type: IdMenuBalancing.Store, modalId: IdModal.Store, activeTabIndex: defaultTabIndex, footerRenderer: footerComponent }));
};
var mapState = function (state) { return ({
    tabId: selectModalTabId(state, IdModal.Store),
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.Store)); },
}); };
export var MenuStore = connect(mapState, mapDispatch)(_MenuStore);



//////////////////
// WEBPACK FOOTER
// ./src/features/store/MenuStore.tsx
// module id = 2932
// module chunks = 3